import { useMemo } from 'react'

import { MeasurementLabelProps } from '@editor/interfaces/canvas/measurementLabel'
import { assign } from 'lodash'

import { DEFAULT_LINE_CONFIG, DEFAULT_TEXT_CONFIG } from '../../TextAnnotation/definitions'

const useConfig = ({ text, line }: MeasurementLabelProps) => {
  // Merge provided text config with defaults.
  // Use refs here instead of useMemo to prevent unnecessary re-renders.
  // If and when the config changes, it will be applied separately.
  const textConfig = useMemo(() => assign({}, DEFAULT_TEXT_CONFIG, text), [text])
  const lineConfig = useMemo(() => assign({}, DEFAULT_LINE_CONFIG, line), [line])

  return { textConfig, lineConfig }
}

export default useConfig
